<template>
  <div class="editDataPageWrap">
    <div class="editData">
      <div class="commonBg"></div>
      <div v-show="page == ''">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon
              class="uploadPage_back"
              name="arrow-left"
              @click="backClick"
            />
            <div class="uploadPage_title">编辑资料</div>
            <van-icon
              name="close"
              v-show="
                $store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                $store.state.isInGame
              "
              @click="closeCommunity"
            />
            <!-- <van-icon class="fork" name="close" /> -->
          </div>
        </div>
        <div class="editData_head" @click="fileClick">
          <div class="editData_head_left">头像</div>
          <div class="editData_head_right">
            <label for="uploads">
              <img :src="img" @error="defImg()" for="uploads" />
            </label>
            <input
              class="editDataPageWrap_imginput"
              :type="file1"
              id="uploads"
              style="position: absolute; clip: rect(0 0 0 0)"
              accept="image/*"
              @change="selectImg($event)"
            />
            <p></p>
          </div>
        </div>
        <label for="changeName">
          <div class="editData_nickname" @click="setnickname">
            <div>昵称</div>
            <div class="editData_nickname_right">
              {{ name }}
              <p></p>
            </div>
          </div>
        </label>
        <!-- add -->
        <div class="editData_sign" @click="setSign" v-show="true">
          <div>个性签名</div>
          <div class="editData_sign_right">
            <i>
              {{ introduce }}
            </i>
            <p></p>
          </div>
        </div>
        <div class="editData_frame" v-if="false">
          <div>头像框</div>
          <div class="">
            <p></p>
          </div>
        </div>
        <div
          class="editData_attestation"
          @click="setAttestation"
          v-show="true && $store.state.gameType != 2 && $store.state.gameType != 4"
        >
          <div>个人认证</div>
          <div class="editData_attestation_right" v-if="auth_info">
            {{ auth_info }}
            <p></p>
          </div>
          <div class="editData_attestation_right" v-if="!auth_info">
            申请个人加V认证
            <p></p>
          </div>
        </div>
        <p class="editData_id" v-show="!attestationFlag">
          社区ID:{{ $store.state.memberId }}
        </p>
      </div>

      <headPortrait
        v-if="page == 'img'"
        :picturePathData="picturePathData"
        @setHeader="setHeader"
        @changeFile1="changeFile1"
        @cancelMethod="cancelMethod"
      ></headPortrait>
      <!-- <nameChange
        v-if="page == 'name'"
        :name="name"
        @cancelMethod="cancelMethod"
      ></nameChange> -->
      <div class="nameChange" v-show="page == 'name'">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon
              class="uploadPage_back"
              name="arrow-left"
              @click="backClick2"
            />
            <div class="uploadPage_title">修改昵称</div>
            <span></span>
            <van-icon
              name="close"
              v-show="
                $store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                $store.state.isInGame
              "
              @click="closeCommunity"
            />
          </div>
        </div>
        <div class="nameChange_content">
          <div class="nameChange_content_inoutbox">
            <van-field id="changeName" v-model="nameText" maxlength="10" />
          </div>
          <div class="nameChange_content_right">
            <div class="nameChange_close" @click="clearName"></div>
            <div
              class="nameChange_btn"
              @click="submitName"
              :class="changeNameFlag ? '' : 'details_input_text_filter'"
            >
              完成
            </div>
          </div>
        </div>
      </div>
      <!-- 个性签名 -->
      <div class="personalSign" v-show="page == 'sign'">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon
              class="uploadPage_back"
              name="arrow-left"
              @click="backClick2"
            />
            <div class="uploadPage_title">个性签名</div>
            <van-icon
              name="close"
              v-show="
                $store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                $store.state.isInGame
              "
              @click="closeCommunity"
            />
            <!-- <van-icon class="fork" name="close" /> -->
          </div>
        </div>
        <div class="personalSign_content">
          <van-field
            v-model="signMessage"
            rows="2"
            autosize
            type="textarea"
            maxlength="20"
            placeholder="填写个性签名，让大家更了解你～"
            show-word-limit
            class="con_sign"
          />
          <span
            class="submitSign"
            @click="submitSign"
            :class="submitSignFlag ? '' : 'details_input_text_filter'"
            >完成</span
          >
        </div>
        <!-- <p class="editData_id">社区ID:{{ $store.state.memberId }}</p> -->
      </div>

      <!-- 个性认证 -->
      <personAttestation
        v-if="attestationFlag"
        :attestationData="attestationData"
        @cancelAttestation="cancelAttestation"
      >
      </personAttestation>
    </div>
    <sideRight v-if="$padFalg != 'other'"></sideRight>
  </div>
</template>
<script>
import headPortrait from './editData/headPortrait.vue';
import nameChange from './editData/nameChange.vue';
import personAttestation from './editData/personAttestation.vue';
import get from '../../../api/get';
import qs from 'qs';
import * as _code from '../../../utils/code';
import { Toast } from 'vant';
import sideRight from '@/components/sideRight';
export default {
  name: 'editData',
  components: {
    headPortrait,
    nameChange,
    sideRight,
    personAttestation
  },
  data() {
    return {
      applets: window.user.weixcode ? 'xcx' : '',
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      nameText: '',
      page: '',
      img: this.$route.query.img,
      name: this.$route.query.name,
      file1: 'hidden', //input数据类型
      changeNameFlag: false,
      attestationFlag: false,
      signMessage: '',
      submitSignFlag: false,
      introduce: '',
      auth_info: '',
      attestationData: {
        name: this.$route.query.name,
        img: this.$route.query.img
      }
    };
  },
  watch: {
    page(ne, ol) {
      if (ne == '') {
        this.getInfo();
      }
      if (ne == 'img') {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      }
    },
    nameText(n, o) {
      if (n == '' || n == this.name) {
        this.changeNameFlag = false;
      } else {
        this.changeNameFlag = true;
      }
    },
    signMessage(n, o) {
      if (n !== this.introduce) {
        this.submitSignFlag = true;
      } else {
        this.submitSignFlag = false;
      }
    }
  },
  mounted() {
    this.getInfo();
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
  },
  methods: {
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //获取本人信息
    getInfo() {
      get.getProfile().then((res) => {
        var data = res.data;
        if (data.code == 0) {
          this.img = data.data.avatar;
          this.name = data.data.nick_name;
          this.introduce = data.data.introduce; //个性签名
          this.auth_info = data.data.auth_info; //个人认证
          this.$store.commit('changeMemberId', data.data.id);
        } else {
          this.errorMessage(data);
        }
      });
    },
    init() {},
    //点击取消时触发
    cancelMethod(event) {
      this.page = '';
    },
    cancelAttestation() {
      this.attestationFlag = false;
    },
    changeFile1() {
      let _this = this;
      _this.file1 = 'text';
      setTimeout(function () {
        _this.file1 = 'file';
      }, 30);
    },
    fileClick() {
      if (this.$store.state.postingFlag) {
        this.file1 = 'file';
      } else {
        Toast('当前无法修改个人信息');
        this.file1 = 'hidden';
      }
      return;
    },
    selectImg(e) {
      let _this = this;
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (ev) {
        _this.picturePathData = ev.target.result;
        _this.page = 'img';
        _this.changeFile1();
      };
    },
    //修改头像提交
    setHeader(url, fun) {
      let obj = {
        avatar: decodeURIComponent(url)
      };
      get
        .avatar(qs.stringify(obj))
        .then((res) => {
          let data = res.data;
          if (data.code == 0) {
            Toast('修改成功');
            this.page = '';
            if (fun) {
              fun();
            }
          } else {
            this.errorMessage(data);
            if (fun) {
              fun();
            }
          }
        })
        .catch(() => {
          if (fun) {
            fun();
          }
        });
    },
    //修改昵称
    setnickname() {
      if (this.$store.state.postingFlag) {
        this.nameText = this.name;
        this.page = 'name';
      } else {
        Toast('当前无法修改个人信息');
      }
    },
    setSign() {
      if (this.$store.state.postingFlag) {
        this.submitSignFlag = false;
        this.page = 'sign';
        this.signMessage = this.introduce;
      } else {
        Toast('当前无法修改个人信息');
      }
    },
    submitSign() {
      let _this = this;
      let introduceData = {
        introduce: this.signMessage
      };
      get.introduce(qs.stringify(introduceData)).then((res) => {
        var data = res.data;
        if (data.code == 0) {
          Toast('设置成功');
          _this.page = '';
        } else {
          _this.errorMessage(data);
        }
      });
    },
    // 个人认证
    setAttestation() {
      if (this.$store.state.postingFlag) {
        this.attestationFlag = true;
      } else {
        Toast('当前无法修改个人信息');
      }
    },
    backClick() {
      this.$router.go(-1);
    },

    clearName() {
      this.nameText = '';
    },
    submitName() {
      if (!this.changeNameFlag) {
        return;
      }
      if (this.nameText == '') {
        Toast('用户名不能为空');
        return;
      }
      let obj = {
        newNickname: this.nameText
      };
      get.nickname(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast('修改成功');
          this.cancelMethod();
        } else {
          if (data.code == 1001) {
            Toast('昵称违规');
          } else {
            this.errorMessage(data);
          }
        }
      });
    },
    backClick2() {
      if (this.$route.query.jump) {
        this.$router.go(-1);
      } else {
        this.cancelMethod();
      }
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        if (this.name != this.nameText) {
          Toast(msg);
        }
      }
    }
  }
};
</script>
<style scoped></style>
